import type { IconSvgObject } from './types';

const BitcoinCircleIcon: IconSvgObject = [
  ["path", { d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9 8.5H10M13.25 12H10M13.25 12C14.2165 12 15 11.2165 15 10.25C15 9.2835 14.2165 8.5 13.25 8.5H12M13.25 12C14.2165 12 15 12.7835 15 13.75C15 14.7165 14.2165 15.5 13.25 15.5H12M10 12V8.5M10 12V15.5M9 15.5H10M10 8.5H12M10 15.5H12M12 8.5V7.5M12 15.5V16.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default BitcoinCircleIcon;
